import React, { useState, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import cx from 'classnames'

import { Box, Button, makeStyles, Typography, CircularProgress } from '@material-ui/core'
import { LocationDisabled, MyLocation } from '@material-ui/icons'

import SeeMore from './SeeMore'

import GEO_PERMISSION_STATUS from '~/Enum/GeoPermissionStatus'
import { fetchReverseGeocode, getPositionBrowser } from '~/geoHelper'
import { useLiterals } from '~/components/Literals'

import actions from '~/actions'
import { permissaoLocalNegada, permissaoSaibaMais } from '~/track'

const useStyle = makeStyles((theme) => ({
  button: {
    textDecoration: 'underline',
    textTransform: 'none',
  },
  loading: {
    textDecoration: 'none',
  },
  buttonIcon: {
    color: theme.palette.primary.main,
  },
  disabled: {
    color: theme.palette.text.disabled,
  },
  deniedMessage: {
    color: theme.palette.error.main,
    fontSize: 14,
    marginTop: 16,
  },
  deniedIcon: {
    marginRight: theme.spacing(2),
    fontSize: 16,
  },
  iconDisabled: {
    color: theme.palette.text.disabled,
  },
  linkSeeMore: {
    textDecoration: 'underline',
    fontWeight: 500,
    display: 'inline',
    cursor: 'pointer',
  },
}))

export default function ButtonPosition({ onChangeLocation }) {
  const classes = useStyle()
  const dispatch = useDispatch()
  const { getLiteral } = useLiterals()
  const { permission: devicePermission } = useSelector((state) => state.position)

  const [showDeniedMessage, setShowDeniedMessage] = useState(false)
  const [showSeeMore, setShowSeeMore] = useState(false)
  const [loading, setLoading] = useState(false)

  const urlReferrer = document.referrer

  const isDeviceNotPermission = devicePermission === GEO_PERMISSION_STATUS.denied
  const isReferrerFacebook = urlReferrer.includes('facebook.com')
  const isLocalhost = window.location.host.includes('localhost')

  const getAddress = async () => {
    if (loading) return
    setLoading(true)

    getPositionBrowser()
      .then((coordinates) => {
        dispatch(actions.position.updatePermission(GEO_PERMISSION_STATUS.granted))
        return fetchReverseGeocode(coordinates)
      })
      .then((location) => {
        onChangeLocation(location)
      })
      .catch((err) => {
        if (err.message === 'User denied Geolocation') {
          permissaoLocalNegada() // track
          setShowDeniedMessage(true)
          dispatch(actions.position.updatePermission(GEO_PERMISSION_STATUS.denied))
        }
      })
      .finally(() => setLoading(false))
  }

  const openSeeMore = () => {
    permissaoSaibaMais() // track
    setShowSeeMore(true)
  }

  const closeSeeMore = () => setShowSeeMore(false)

  const renderButtonSharePosition = useMemo(() => {
    if (isLocalhost) return true

    if (isReferrerFacebook) return false
    if (!urlReferrer) return true
    if (urlReferrer && urlReferrer.includes('https')) return true

    return false
  }, [isReferrerFacebook, isLocalhost, urlReferrer])

  return (
    renderButtonSharePosition && (
      <Box display={'flex'} justifyContent={'center'} alignItems={'center'} flexDirection="column">
        <Button
          className={cx(classes.button, {
            [classes.disabled]: isDeviceNotPermission,
            [classes.loading]: loading,
          })}
          startIcon={
            loading ? (
              <CircularProgress size={18} color="primary" />
            ) : (
              <MyLocation
                className={cx(classes.buttonIcon, {
                  [classes.iconDisabled]: isDeviceNotPermission,
                })}
              />
            )
          }
          onClick={getAddress}
          disabled={isDeviceNotPermission || loading}
        >
          {loading ? getLiteral('3336') : getLiteral('2055')}
        </Button>

        {showDeniedMessage && (
          <Typography component="div" className={classes.deniedMessage}>
            <Box display="flex">
              <LocationDisabled className={classes.deniedIcon} />
              <Box>
                {getLiteral('2509')}
                <strong>{getLiteral('2510')}</strong>
                <br />
                <br />
                {getLiteral('2511')},{' '}
                <a className={classes.linkSeeMore} onClick={openSeeMore}>
                  {getLiteral('2512')}
                </a>
              </Box>
            </Box>
          </Typography>
        )}

        <SeeMore open={showSeeMore} onClose={closeSeeMore} />
      </Box>
    )
  )
}
